module.exports = __webpack_public_path__ + "img/0-73.fcbde523.jpg";